export default {
  dismissText: 'åæ¶'
};
